import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@zola/zola-ui';

const ToggleTooltip = ({ closeTooltip }) => (
  <div className="got-it-tooltip">
    <div className="got-it-tooltip__text">
      Make this page visible to let guests RSVP on your website.
    </div>
    <Link className="got-it-tooltip__btn" role="button" onClick={closeTooltip}>
      Got it!
    </Link>
  </div>
);

ToggleTooltip.propTypes = {
  closeTooltip: PropTypes.func.isRequired,
};

export default ToggleTooltip;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/Rsvp/ToggleTooltip.jsx